import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M10 18a8 8 0 004.9-1.7l4.4 4.4 1.4-1.4-4.4-4.4A8 8 0 1010 18zm0-14a6 6 0 110 12 6 6 0 010-12z" }));
export {
  a as ReactComponent
};
